import { usePermissions } from "components/context/permissionsContext";

export const useAssessmentPermission = () => {
  const { userPermissions } = usePermissions();

  const hasAssessmentGetPermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "Assessment" &&
      item.identifier === "assessment-get" &&
      item.hasPermission
  );
  const hasAssessmentSavePermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "Assessment" &&
      item.identifier === "assessment-save" &&
      item.hasPermission
  );
  const hasAssessmentDeletePermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "Assessment" &&
      item.identifier === "assessment-delete" &&
      item.hasPermission
  );

  const AssessmentPermissionProps = {
    hasAssessmentGetPermission,
    hasAssessmentSavePermission,
    hasAssessmentDeletePermission,
  };

  return {
    AssessmentPermissionProps,
  };
};
